import { ReactNode, useRef } from "react";
import Modal, { useModalState } from "./Modal";
import PrimaryButton from "./button/PrimaryButton";
import SecondaryButton from "./button/SecondaryButton";

type Props = {
  isOpen: boolean;
  title?: string;
  content: string | ReactNode;
  onContinue: () => void;
  onCancel: () => void;
  canContinue?: boolean;
};

export default function ConfirmationModal({
  isOpen,
  title,
  content,
  onContinue,
  onCancel,
  canContinue = true,
}: Props) {
  const cancelButtonRef = useRef(null);
  const [, setOpen] = useModalState({ isOpen });

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      content={content}
      controls={
        <>
          <PrimaryButton
            disabled={!canContinue}
            onClick={() => {
              setOpen(false);
              onContinue();
            }}
          >
            Continue
          </PrimaryButton>
          <SecondaryButton
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-3xl bg-white px-6 py-2 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all hover:bg-gray-50 sm:mt-0 sm:w-auto"
            onClick={() => {
              setOpen(false);
              onCancel();
            }}
            innerRef={cancelButtonRef}
          >
            Cancel
          </SecondaryButton>
        </>
      }
    />
  );
}
